import { render, staticRenderFns } from "./ResourceCenterTable.vue?vue&type=template&id=81784d72&scoped=true"
import script from "./ResourceCenterTable.vue?vue&type=script&lang=js"
export * from "./ResourceCenterTable.vue?vue&type=script&lang=js"
import style0 from "./ResourceCenterTable.vue?vue&type=style&index=0&id=81784d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81784d72",
  null
  
)

export default component.exports